module.exports = __webpack_public_path__ + "img/red-hammock-between-wall-3255245.7fc03f54.jpg";